import produce from "immer";
import moment from "moment";
import { constants } from "./actions";
import { commonConstants } from "../common/actions";
import getLookups from "../../views/Config/lookups";
import clearPersistedLocalStorage from "../../utils/persistedLocalStorage";
import { headTraumaUtils } from "./utils";

const { REQUEST, SUCCESS, FAILURE } = commonConstants;
const {
  UPDATE_QUESTIONNAIRE_FORM_FIELD,
  RESET_FORM_FIELDS,
  SUBMIT_FORM,
} = constants;
const { countries, callEntryTypes, headTraumaChecks } = getLookups();
const { cleanHeadTraumas } = headTraumaUtils(headTraumaChecks);

const initState = {
  callEntryType: callEntryTypes[0],
  name: "",
  email: "",
  cellPhone: "",
  homePhone: "",
  isFrequentCaller: null,
  isVeteran: null,
  veteranBranch: "",
  yearsOfMilitaryService: "",
  isDisabled: null,
  receivedVaTreatment: null,
  gender: null,
  veteranRank: "",
  yearsOfPoliceService: "",
  country: countries[0],
  provinceState: "",
  city: "",
  departmentSize: "",
  callerType: "",
  age: "",
  coplineReferral: "",
  impairment: "",
  currentStruggle: "",
  callStart: moment(),
  callEnd: moment(),
  callReason: "",
  isSuicidalCall: null,
  callWasReferred: false,
  referralDetails: "",
  returnCall: false,
  returnCallDate: null,
  returnCallDetails: "",
  safeReturnCallDetails: "",
  returnCallFollowUpNotes: "",
  resolvedReturnCalls: [],
  unResolvedReturnCalls: [],
  originCallReportId: 0,
  callType: "ORIGIN",
  combatExperience: null,
  treatedForPtsd: null,
  otherMedicalCondition: null,
  headTraumaCheck: headTraumaChecks.REPORTED,
  headTrauma: [],
  // async
  loading: {},
  error: {},
  success: {},
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case UPDATE_QUESTIONNAIRE_FORM_FIELD:
      if (action.field === "returnCall" && action.value) {
        return produce(state, (draft) => {
          draft[action.field] = action.value;
          draft.loading = {};
          draft.error = {};
          draft.success = {};
          draft.returnCallDate = new Date();
        });
      }
      return produce(state, (draft) => {
        draft[action.field] = action.value;
        draft.loading = {};
        draft.error = {};
        draft.success = {};
        if (action.field === "headTraumaCheck") {
          draft.headTrauma = cleanHeadTraumas(action.value);
        }
      });
    case RESET_FORM_FIELDS:
      const success = {
        source: RESET_FORM_FIELDS,
        message: "All form fields were successfully reset.",
      };
      if (!action.payload.showMessage) {
        delete success.message;
      }
      state = {
        ...initState,
        success,
        loading: {},
        error: {},
      };
      clearPersistedLocalStorage();
      return state;
    case SUBMIT_FORM + REQUEST:
      return produce(state, (draft) => {
        draft.loading = { source: SUBMIT_FORM };
        draft.success = {};
        draft.error = {};
      });
    case SUBMIT_FORM + SUCCESS:
      clearPersistedLocalStorage();
      return produce(initState, (draft) => {
        draft.success = {
          source: action.payload.source,
          message: action.payload.message,
        };
      });
    case SUBMIT_FORM + FAILURE:
      return produce(state, (draft) => {
        draft.loading = {};
        draft.success = {};
        draft.error = {
          source: action.payload.source,
          message: action.payload.message,
        };
      });
    default:
      return state;
  }
}
